export default __webpack_public_path__ + "static/award-04-4b9a5f7821fa6bcfc9a2237043085d0e.png";